import { withBemMod } from '@bem-react/core';

import { cnButton } from '../../Button.cn';

import './Button_view_float.css';

export type WithViewFloatProps = {
    view?: 'float';
};

export const withViewFloat = withBemMod<WithViewFloatProps>(cnButton(), {});
